import {EarningsEntry} from "jobjump-types/Earnings";
import { fetchWithAuth } from "./Utils";

const EarningsAPI = {
    getEarnings : () : Promise<EarningsEntry[]> => 
        fetchWithAuth("api/earnings/").then((r) =>r.json()).catch(console.log)
};

export default EarningsAPI;